import { getActiveRestaurantId } from "../utils/activeRestaurant";
import { useEffect, useState } from "react";
import { ILoginInfo } from "../models/ILoginInfo";
import { decrypt } from "../utils/Util";
import MyFoods from "../components/MyFoods";

function AddFoodPage() {
  const [restaurantId, setRestaurantId] = useState<string>("");

  useEffect(() => {
    const userJson = localStorage.getItem("user");
    if (userJson) {
      const encUser: ILoginInfo = JSON.parse(decrypt(userJson));
      setRestaurantId(getActiveRestaurantId());
    }
  }, []);

  return (
    <div className="container mt-4">
      <MyFoods
        selectedRestaurantId={restaurantId}
        onSelectFood={() => {}}
      />
    </div>
  );
}

export default AddFoodPage;